import {
  ExpressionKeyField,
  FireWallExpressionCondition,
  FirewallAction,
} from "../../../../../utils/constants";

export const FIREWALL_RULES_PATH = "/v2/services/firewall_rules";

/**
 * Build location.state for opening the firewall create modal with a block rule
 * prefilled for the given source IP and site.
 */
export function buildFirewallBlockIpState(sourceIp, siteLabel) {
  const ip = sourceIp != null ? String(sourceIp).trim() : "";
  if (!ip) return null;

  const site = siteLabel != null ? String(siteLabel).trim() : "";
  const name = site ? `${site} ${ip}` : `Block IP ${ip}`;

  return {
    openCreate: true,
    prefilled: {
      name,
      action: FirewallAction.BLOCK,
      conditions: [
        [
          {
            key: ExpressionKeyField.SOURCE_IP,
            condition: FireWallExpressionCondition.EQUALS,
            value: ip,
          },
        ],
      ],
    },
  };
}
